import { render, staticRenderFns } from "./TableResumeUrlShort.vue?vue&type=template&id=21d1594a&scoped=true&"
import script from "./TableResumeUrlShort.vue?vue&type=script&lang=js&"
export * from "./TableResumeUrlShort.vue?vue&type=script&lang=js&"
import style0 from "./TableResumeUrlShort.vue?vue&type=style&index=0&id=21d1594a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1594a",
  null
  
)

export default component.exports